import Vue from 'vue'
import VueRouter from 'vue-router'
import PouchDB from 'pouchdb'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    // *===============================================---*
    // *--------- ACCUEIL  ---------------------------------------*
    // *===============================================---*
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Dashboard',
      },
    },
    // *===============================================---*
    // *--------- SYNCDB  ---------------------------------------*
    // *===============================================---*
    {
      path: '/syncdb',
      name: 'syncdb',
      component: () => import('@/views/SyncDB.vue'),
      meta: {
        pageTitle: 'SyncDB',
        layout: 'full',
      },
    },

    // *===============================================---*
    // *--------- CLIENTS  ---------------------------------------*
    // *===============================================---*
    {
      path: '/clients/listclient',
      name: 'listclient',
      component: () => import('@/views/apps/clients/ClientList.vue'),
      meta: {
        authRequired: true,
        pageTitle: 'Liste des clients',
        breadcrumb: [
          {
            text: 'Liste des clients',
            active: true,
          },
        ],
      },
    },
    {
      path: '/clients/viewclient/:id',
      name: 'viewclient',
      component: () => import('@/views/apps/clients/ClientView'),
      meta: {
        authRequired: true,
        pageTitle: 'Détails client',
        breadcrumb: [
          {
            text: 'Détails client',
            active: true,
          },
        ],
      },
    },

    // *===============================================---*
    // *--------- ARTICLES ---------------------------------------*
    // *===============================================---*
    {
      path: '/articles/listarticle',
      name: 'listarticle',
      component: () => import('@/views/apps/articles/ArticleList.vue'),
      meta: {
        authRequired: true,
        pageTitle: 'Liste des articles',
        breadcrumb: [
          {
            text: 'Liste des articles',
            active: true,
          },
        ],
      },
    },
    {
      path: '/articles/viewarticle/:id',
      name: 'viewarticle',
      component: () => import('@/views/apps/articles/ArticleView'),
      meta: {
        authRequired: true,
        pageTitle: 'Détails articles',
        breadcrumb: [
          {
            text: 'Détails articles',
            active: true,
          },
        ],
      },
    },
    // *===============================================---*
    // *--------- COMMANDES ---------------------------------------*
    // *===============================================---*
    {
      path: '/commande/newcommande',
      name: 'newcommande',
      component: () => import('@/views/apps/commande/CommandeNew.vue'),
      meta: {
        authRequired: true,
        pageTitle: 'Nouvelle commande',
        breadcrumb: [
          {
            text: 'Nouvelle commande',
            active: true,
          },
        ],
      },
    },
    {
      path: '/commande/listcommande',
      name: 'listcommande',
      component: () => import('@/views/apps/commande/CommandeList.vue'),
      meta: {
        authRequired: true,
        pageTitle: 'Liste des commandes',
        breadcrumb: [
          {
            text: 'Liste des commandes',
            active: true,
          },
        ],
      },
    },
    {
      path: '/commande/viewcommande',
      name: 'viewcommande',
      component: () => import('@/views/apps/commande/CommandeView.vue'),
      meta: {
        authRequired: true,
        pageTitle: 'Détails commande',
        breadcrumb: [
          {
            text: 'Détails commande',
            active: true,
          },
        ],
      },
    },
    {
      path: '/invoice',
      name: 'invoice',
      component: () => import('@/views/apps/invoice/InvoicePreview.vue'),
      meta: {
        authRequired: true,
        pageTitle: 'Commande',
        breadcrumb: [
          {
            text: 'Impression commande',
            active: true,
          },
        ],
      },
    },
    // *===============================================---*
    // *--------- AUTRES ---------------------------------------*
    // *===============================================---*
    {
      path: '/listdocs',
      name: 'listdocs',
      component: () => import('@/views/docsList.vue'),
      meta: {
        authRequired: true,
        pageTitle: 'Liste des documents',
        breadcrumb: [
          {
            text: 'Liste des documents',
            active: true,
          },
        ],
      },
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/editProfile.vue'),
      meta: {
        pageTitle: 'Profile',
        breadcrumb: [
          {
            text: 'Profile',
            active: true,
          },
        ],
      },
    },
    {
      path: '/setting',
      name: 'setting',
      component: () => import('@/views/editSetting.vue'),
      meta: {
        pageTitle: 'Setting',
        breadcrumb: [
          {
            text: 'Setting',
            active: true,
          },
        ],
      },
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('@/views/Test.vue'),
      meta: {
        pageTitle: 'Test',
        breadcrumb: [
          {
            text: 'Test',
            active: true,
          },
        ],
      },
    },
    {
      path: '/testview/:id',
      name: 'testview',
      component: () => import('@/views/TestView.vue'),
      meta: {
        authRequired: true,
        pageTitle: 'Test view',
        breadcrumb: [
          {
            text: 'Test view',
            active: true,
          },
        ],
      },
    },
    {
      path: '/upload',
      name: 'upload',
      component: () => import('@/views/Upload.vue'),
      meta: {
        authRequired: true,
        pageTitle: 'Upload photos',
        breadcrumb: [
          {
            text: 'Upload photos',
            active: true,
          },
        ],
      },
    },
    {
      path: '/imagemanager',
      name: 'imagemanager',
      component: () => import('@/views/ImageManager.vue'),
      meta: {
        authRequired: true,
        pageTitle: 'Images manager',
        breadcrumb: [
          {
            text: 'Images manager',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  console.log('Configuration trouvé')
  const sessionDB = new PouchDB(localStorage.getItem('url') + '/_session')
  sessionDB.getSession().then(response => {
    console.log('getSession', response)
    if (!response.userCtx.name) {
      console.log("Personne n'est connecté")
      localStorage.removeItem('user')
      localStorage.removeItem('role')
      localStorage.removeItem('setting')
      next({ path: '/login' })
    } else if (response.userCtx.roles.includes(localStorage.getItem('database')) != true) {
      console.log('Utilisateur non autorisé')
      localStorage.removeItem('user')
      localStorage.removeItem('role')
      localStorage.removeItem('setting')
      next({ path: '/login' })
    } else if (!localStorage.getItem('user') || !localStorage.getItem('role')) {
      console.log('Utilisateur non autorisé')
      localStorage.removeItem('user')
      localStorage.removeItem('role')
      localStorage.removeItem('setting')
      next({ path: '/login' })
    } else {
      console.log('local user', localStorage.getItem('user'))
      console.log('local role', localStorage.getItem('role'))
    }
  }).catch(error => {
    if (!error.error) {
      console.log('Error local user', localStorage.getItem('user'))
      console.log('Error local role', localStorage.getItem('role'))
      console.log('Error: Network Error')
      if (!localStorage.getItem('url') || !localStorage.getItem('database')) {
        next({ path: '/login' })
      }
      // this.errorStatus = 'Error: Network Error';
    } else {
      console.log(error.message)
      next({ path: '/login' })
      // this.errorStatus = error.message;
    }
    console.error('error', this.errorStatus)
  })

  // const loggedIn = localStorage.getItem('user')

  if (to.matched.some(record => record.meta.authRequired)) {
    if (localStorage.getItem('user')) {
      next()
    } else {
      next({ path: '/login' })
    }
  } else {
    next()
  }
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
